import Slider from "_shared/components/Slider/Slider";
import plans from "_shared/constants/plans";
import styles from "./PlanSelection.module.scss";
import clsx from "clsx";

interface Props {
  value: number;
  onChange: (value: number) => void;
  expiringPlan?: number;
}

const PlanSlider: React.FC<Props> = ({ value, onChange, expiringPlan }) => {
  return (
    <form className={styles.sliderContainer}>
      <div className={styles.slider}>
        <Slider
          name="plan"
          max={plans.length - 1}
          min={0}
          value={value}
          onChange={(vals) => onChange(vals[0])}
          minRangeDisplay={expiringPlan}
        />
      </div>
      <div className={styles.planNames}>
        {plans.map((plan, i) => {
          const isExpiring = i === expiringPlan;
          return (
            <label
              htmlFor="plan"
              key={i}
              className={clsx(
                styles.planName,
                isExpiring && value < i && styles.expiring,
              )}
              onClick={() => onChange(i)}
            >
              {plan.name}
            </label>
          );
        })}
      </div>
    </form>
  );
};

export default PlanSlider;
